import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ApplicationService } from 'src/app/services/application-service';
import { Subscription, timer } from 'rxjs';
import { ApplicationsApiService } from 'src/app/services/api/applications-api.service';
import { handleApiError } from 'src/app/utils/error';
import { TranslateService } from '@ngx-translate/core';
import { parseLocaleNumber } from 'src/app/utils/format-currency';
import { LocaleService } from 'src/app/services/locale.service';
import { FlowService } from 'src/app/services/flow.service';
import { TrackingService } from 'src/app/services/tracking.service';
import { ApplicationScoreService } from 'creddo-shared-library';

@Component({
  selector: 'app-securities',
  templateUrl: './securities.component.html',
  styleUrls: ['./securities.component.scss'],
})
export class SecuritiesComponent implements OnInit, OnDestroy {
  form!: FormGroup;
  subs: Array<Subscription> = [];
  error = '';
  locale!: string;
  requestPending = false;
  @Input() isSummary!: boolean;

  constructor(
    private applicationService: ApplicationService,
    private applicationApiService: ApplicationsApiService,
    private translateService: TranslateService,
    private localeService: LocaleService,
    public flowService: FlowService,
    protected trackingService: TrackingService,
    private applicationScoreService: ApplicationScoreService
  ) {}

  ngOnInit(): void {
    this.locale = this.localeService.locale;
    const initialFactoring = this.applicationService.factoring;
    const initialCompanyMortgage = this.applicationService.companyMortgage;

    this.form = new FormGroup({
      factoring: new FormControl(initialFactoring, { updateOn: 'blur' }),
      companyMortgage: new FormControl(initialCompanyMortgage, {
        updateOn: 'blur',
      }),
    });

    this.subs.push(
      this.factoring.valueChanges.subscribe((v: number) => {
        this.requestPending = true;
        if (typeof v === 'string') {
          v = parseLocaleNumber(v, this.locale);
          this.applicationService.factoring = v;
        }

        // Update barometer score
        this.applicationScoreService.updateAppScore(
          'factoring',
          v ? true : false
        );

        this.updateApplication('factoring', v);
        this.trackFields('factoring');
      })
    );
    this.subs.push(
      this.companyMortgage.valueChanges.subscribe((v: number) => {
        this.requestPending = true;
        if (typeof v === 'string') {
          v = parseLocaleNumber(v, this.locale);
          this.applicationService.companyMortgage = v;
        }

        // Update barometer score
        this.applicationScoreService.updateAppScore(
          'companyMortgage',
          v ? true : false
        );

        this.updateApplication('companyMortgage', v);
        this.trackFields('companyMortgage');
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.map((sub) => sub.unsubscribe());
  }

  get factoring(): FormControl {
    return this.form.get('factoring') as FormControl;
  }

  get companyMortgage(): FormControl {
    return this.form.get('companyMortgage') as FormControl;
  }

  get cardTitle(): string {
    return this.translateService.instant('securities.title');
  }

  updateApplication(key: string, value: number): void {
    const body = {
      applicationId: this.applicationService.applicationId,
      [key]: value,
    };
    this.applicationApiService.addSecurity(body).subscribe(
      () => (this.error = ''),
      (error: any) =>
        (this.error = handleApiError(error, this.translateService)),
      () => (this.requestPending = false)
    );
  }

  handleBackButtonClick(): void {
    this.subs.push(
      timer(1000, 1000).subscribe(() => {
        if (!this.requestPending) {
          this.flowService.previousScreen();
        }
      })
    );
  }

  handleContinueButtonClick(): void {
    this.subs.push(
      timer(1000, 1000).subscribe(() => {
        if (!this.requestPending) {
          this.flowService.nextScreen();
        }
      })
    );
  }

  trackFields(field: string): void {
    this.trackingService.filledField(field);
  }
}
